import gql from 'graphql-tag';

export const GET_WP_USER_INFO = gql`
  query {
    getWPUserInfo {
      id
      username
      initials
      email
      teams {
        id
        name
        directed_learning_name
      }
      teams_where_learner {
        id
        name
        directed_learning_name
      }
      teams_where_manager {
        id
        name
        directed_learning_name
      }
      subscription
      manager
    }
  }
`;

export const GET_TEAMS_INFO = gql`
  query listWPTeamMembers($filter: TeamFilter!) {
    listWPTeamMembers(filter: $filter) {
      id
      name
      email
      team_id
    }
  }
`;

export const GET_ALGOLIA_API_KEY = gql`
  query {
    getAlgoliaApiKey {
      api_key
    }
  }
`;

export const GET_EXPERT_BY_SLUG = gql`
  query($slug: String) {
    getFilteredUsers(filter: { slug: [$slug] }) {
      id
      name
      avatar
      job_title
      description
      count_videos
      slug
    }
  }
`;
